export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
}

export enum Role {
  ROLE_REL_OMISSAO = 'ROLE_REL_OMISSAO',
  ROLE_REL_ENTREGA_DESTDA = 'ROLE_REL_ENTREGA_DESTDA',
  ROLE_REL_ENTREGA_EFD = 'ROLE_EFD_REL_EXTRATO_PROC',
  ROLE_EFD_CONSULTA_EXTRATO_EFD = 'ROLE_EFD_CONS_EXTRATO_EFD'
}
